import { ReturnContractStatusEnum } from '@crm/api'
import { createStyles, FullToken } from 'antd-style'

const statusDotColor: Record<ReturnContractStatusEnum, keyof FullToken> = {
  [ReturnContractStatusEnum.SIGNED]: 'colorInfo',
  [ReturnContractStatusEnum.CLOSED]: 'colorSuccess'
}

export const useStyles = createStyles(
  ({ token }, props?: { color?: ReturnContractStatusEnum }) => ({
    statusDot: {
      width: 6,
      height: 6,
      borderRadius: '100%',
      backgroundColor: props?.color
        ? (token[statusDotColor[props.color]] as string)
        : token.colorBgMask
    },

    statusColor: {
      color: props?.color
        ? (token[statusDotColor[props.color]] as string)
        : token.colorBgMask
    }
  })
)
